// extracted by css-extract-rspack-plugin
export default {"shimmer":"_c7a1c18c","shimmerLoadingBackground":"_e6920ea4"};